export default __webpack_public_path__ + "static/media/screenBlock4.97b44386.jpg";